import { oz } from '@weft/utils';

export const DeletedEntitySchema = oz.object({
  deletedAt: oz.date(),
});

export type DeletedEntity = oz.infer<typeof DeletedEntitySchema>;